export const ORDERS_CHANGE_VIEW_SEARCH = 'ORDERS_CHANGE_VIEW_SEARCH';
export const changeViewSearch = (searchData, setPageToOne = true) => ({
  type: ORDERS_CHANGE_VIEW_SEARCH,
  searchData,
  setPageToOne,
});

export const ORDERS_GET_COUNTS_SUCCESS = 'ORDERS_GET_COUNTS_SUCCESS';
export const ordersGetCountsSuccess = (counts) => ({
  type: ORDERS_GET_COUNTS_SUCCESS,
  counts,
});

export const ORDERS_GET_SEARCH_COUNTS = 'ORDERS_GET_SEARCH_COUNTS';
export const ordersSearchTermCount = () => ({
  type: ORDERS_GET_SEARCH_COUNTS,
});

export const CLEAR_SEARCH_INPUT = 'CLEAR_SEARCH_INPUT';
export const clearSearchInput = () => ({
  type: CLEAR_SEARCH_INPUT,
});

export const SEARCH_TERM_CHANGE = 'SEARCH_TERM_CHANGE';
export const handleSearchTermChange = (searchValue) => ({
  type: SEARCH_TERM_CHANGE,
  searchValue,
});

export const QUICKSEARCH_FROM_SCAN_TO_SEARCH = 'QUICKSEARCH_FROM_SCAN_TO_SEARCH';
export const quickSearchFromScanToSearch = (searchTerm, viewId, history) => ({
  type: QUICKSEARCH_FROM_SCAN_TO_SEARCH,
  searchTerm,
  viewId,
  history,
});
